// extracted by mini-css-extract-plugin
export default {"sidebarWrapper":"Sidebar_sidebarWrapper__QOAKD","hamburger":"Sidebar_hamburger__RDdE-","sidebarContainer":"Sidebar_sidebarContainer__UwQ+v","open":"Sidebar_open__SToGL"};